import { BackMaterialInfo } from '@types'

export function getTextureImage(texture: BackMaterialInfo) {
  if (texture.urlMiniatura !== null) {
    return encodeURI(texture.urlMiniatura)
  } else {
    return encodeURI(texture.url)
  }
}
